/* RESPONSIBLE TEAM: team-proactive-support */
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { inject as service } from '@ember/service';

export default class TeamPerformanceRoute extends IntercomRoute {
  @service customReportsService;

  beforeModel() {
    this.customReportsService.routeToOverviewPage();
  }
}
